import {
	SET_START_SCHEDULE,
	SET_SELECTED_SERVICES,
	SET_VEHICLE_SCHEDULE,
	SET_DATE_SCHEDULE,
	SET_TIME_SCHEDULE,
	SET_CUSTOMER_INFO,
	CLEAR_SCHEDULE_DATA,
	SET_SCHEDULE_ERR,
	SET_STEP,
	UPDATE_SELECTED_OPTIONAL_SERVICES,
} from './mutation-types'

export const actions = {
	setStartSchedule({ commit, state }) {
		try {
			// commit(CLEAR_SCHEDULE_DATA)
			commit(SET_START_SCHEDULE, true)
			return true
		}
		catch ({ err }) {
			commit(SET_START_SCHEDULE, false)
			return err
		}
	},
	setSelectedServices({ commit, state }, payload) {
		try {
			commit(SET_SELECTED_SERVICES, payload)
			return true
		}
		catch ({ err }) {
			return err
		}
	},
	setVehicleSchedule({ commit, state }, payload) {
		try {
			commit(SET_VEHICLE_SCHEDULE, payload)
			return true
		}
		catch ({ err }) {
			return err
		}
	},
	setDateSchedule({ commit, state }, payload) {
		try {
			commit(SET_DATE_SCHEDULE, payload)
			return true
		}
		catch ({ err }) {
			return err
		}
	},
	setTimeSchedule({ commit, state }, payload) {
		try {
			commit(SET_TIME_SCHEDULE, payload)
			return true
		}
		catch ({ err }) {
			return err
		}
	},
	setScheduleErr({ commit, state }, payload) {
		try {
			commit(SET_SCHEDULE_ERR, payload)
			return true
		} catch ({ err }) {
			return err
		}
	},
	setCustomerInfo({commit, state}, payload) {
		try{
			commit(SET_CUSTOMER_INFO, payload);
			return true;
		} catch({err}) {
			return err;
		}
	},
	clearScheduleData({ commit, state }) {
		try {
			commit(CLEAR_SCHEDULE_DATA);
			return true;
		} catch ({ err }) {
			return err
		}
	},
	setStep({commit}, value) {
		try {
			commit(SET_STEP, value);
			return true;
		} catch ({ err }) {
			return err
		}
	},
	removeOptionalServiceById({commit, state}, id) {
		try {
			const services = state.selectedOptionalServices.filter(service => service.bestOneServiceID !== id);
			commit(UPDATE_SELECTED_OPTIONAL_SERVICES, services);
			return true;
		} catch ({ err }) {
			return err
		}
	},
}